import React from 'react'

/** A word card standing in a card holder; the holder fills once the word is in the pocket. */
export const PocketIcon: React.FC<{ filled?: boolean; size?: number }> = ({ filled = false, size = 16 }) => (
  <svg width={size} height={size} viewBox='0 0 16 16' aria-hidden='true'>
    <g
      className='pt-card'
      fill='none'
      stroke='currentColor'
      strokeWidth='1.3'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <path d='M3.4 7.4v-4c0-.6.4-1 1-1h7.2c.6 0 1 .4 1 1v4' />
      <path d='M5.6 4.9h3.4' />
    </g>
    <rect
      x='1.9'
      y='7.4'
      width='12.2'
      height='6.8'
      rx='1.8'
      fill={filled ? 'currentColor' : 'none'}
      stroke='currentColor'
      strokeWidth='1.3'
    />
  </svg>
)
